import React from "react";
import { format } from "date-fns";
import { activityConfig } from "app/containers/Features/containers/User/containers/Activity/components/activityMapping";

export const renderDescription = (text: string) => {
  const parts = text.split(/(['"].*?['"])/g);
  return parts.map((part, index) => {
    const isQuoted =
      (part.startsWith("'") && part.endsWith("'")) ||
      (part.startsWith('"') && part.endsWith('"'));
    if (isQuoted) {
      return (
        <span key={index} className="text-black font-medium">
          {part}
        </span>
      );
    }
    return (
      <span key={index} className="">
        {part}
      </span>
    );
  });
};

interface FormatDescriptionParams {
  activityName: string;
  activityDescription: any;
  displayMemberName: string;
  selectedTeam: any;
}

export const formatAuditLogDescription = ({
  activityName,
  activityDescription,
  displayMemberName,
  selectedTeam,
}: FormatDescriptionParams) => {
  if (typeof activityDescription === "string") return activityDescription;

  const config = activityConfig[activityName];
  let template = config?.template || activityName;

  const meta: any = activityDescription || {};
  const context = {
    ...(typeof meta === "object" ? meta : {}),
    member_name: displayMemberName,
    team_name: selectedTeam?.teamName || "",
    project_name: meta?.projectName || "",
    ticket_name: meta?.ticketName || meta?.title || "",
  };

  if (context) {
    Object.entries(context).forEach(([key, value]) => {
      const placeholder = new RegExp(`\\{${key}\\}`, "g");
      template = template.replace(placeholder, String(value ?? ""));
    });
  }

  return template;
};

export const getLogTime = (createdAt: string) => {
  const dateObj = new Date(createdAt);
  return !isNaN(dateObj.getTime()) ? format(dateObj, "p") : "-";
};

export const formatMemberName = (name: string) => {
  if (!name) return "";
  return name
    .replace(/[-_]/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase())
    .trim();
};
